import { render, staticRenderFns } from "./VideoTile.vue?vue&type=template&id=178fd3d3&scoped=true&"
import script from "./VideoTile.vue?vue&type=script&lang=js&"
export * from "./VideoTile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "178fd3d3",
  null
  
)

export default component.exports